import Preloader from './components/Partials/Preloader.vue';

export default {
    props: ['translations'],

    components: {
        Preloader,
    },

    created(){
        this.$i18nApi.setTranslations(JSON.parse(this.translations));
    }
}
